<template>
  <div class="input-container">
    <div class="field-name">
      <img class="field-icon" :src="iconUrl">
      <span>{{ title }}</span>
    </div>
    <div>
      <button
        type="button"
        class="btn btn-default btn-block filter-button"
        @click="toggle"
      >
        <span class="current-option">{{ optionName }}</span>
        <span class="down-arrow">
          <span 
            class="glyphicon"
            :class="{ 'glyphicon-chevron-down': !active, 
            'glyphicon-chevron-up': active }"
          ></span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'iconUrl', 'title', 'optionName', 'active' ],
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<style scoped>
.input-container {
  background: #ffffbb;
  margin: 5px 0;
  padding: 5px;
  border-radius: 4px;
}

.field-name {
  display: flex;
  font-weight: 400;
  font-size: 16px;
}

.field-icon {
  width: 16px;
  height: auto;
  margin-right: 5px;
  align-self: center;
}

.filter-button {
  text-align: left;
  background: #ffffbb;
  padding: 4px 0 0 0;
  box-shadow: unset;
  outline-width: 0px;
  display: flex;
  justify-content: space-between;
}

.filter-button:focus, .filter-button:active, .filter-button:hover {
  background: #ffffbb;
  outline-width: 0px;
  box-shadow: unset;
}

.filter-button.active:hover {
  box-shadow: unset;
}

.current-option {
  color: #8D8D8D;
  font-size: 14px;
  white-space: break-spaces;
}

.down-arrow {
  font-size: 16px;
}
</style>